<template>
  <a-layout :class="['layout', device]">
    <a-drawer v-if="isMobile()" :closable="false" :visible="collapsed" :wrapClassName="`drawer-sider ${navTheme}`" placement="left" @close="drawerClose">
      <side-menu :collapsed="false" :collapsible="true" :menus="menus" :theme="navTheme" mode="inline" @menuSelect="menuSelect" />
    </a-drawer>
    <side-menu v-else-if="isSideMenu()" :collapsed="collapsed" :collapsible="true" :menus="menus" :theme="navTheme" mode="inline" />
    <a-layout :class="[layoutMode, `content-width-${contentWidth}`]" :style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh' }">
      <global-header :collapsed="collapsed" :device="device" :menus="menus" :mode="layoutMode" :theme="navTheme" @toggle="toggle" />
      <a-layout-content :style="{ height: '100%', margin: '24px 1px 0', paddingTop: fixedHeader ? '64px' : '0' }">
        <multi-tab v-if="multiTab" />
        <transition name="page-transition">
          <route-view />
        </transition>
      </a-layout-content>
      <setting-drawer v-if="!production" />
    </a-layout>
  </a-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mixin, mixinDevice } from '@/utils/mixin'
import config from '@/config/defaultSettings'

import RouteView from './RouteView'
import MultiTab from '@/components/MultiTab'
import SideMenu from '@/components/Menu/SideMenu'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
import SettingDrawer from '@/components/SettingDrawer'

export default {
    name: 'BasicLayout',
    mixins: [mixin, mixinDevice],
    components: {
      RouteView,
      MultiTab,
      SideMenu,
      GlobalHeader,
      GlobalFooter,
      SettingDrawer
    },
    data() {
      return {
        production: config.production,
        collapsed: true,
        menus: []
      }
    },
    computed: {
      ...mapState({
        mainMenu: state => state.permission.addRouters
      }),
      contentPaddingLeft() {
        if (!this.fixSidebar || this.isMobile()) {
          return '0'
        }
        if (this.sidebarOpened) {
          return '256px'
        }
        return '40px'
      }
    },
    watch: {
      sidebarOpened(val) {
        this.collapsed = !val
      }
    },
    created() {
      this.menus = this.mainMenu.find(item => item.path === '/').children
      this.collapsed = !this.sidebarOpened
      this.collapsed = true
    },
    mounted() {
      const userAgent = navigator.userAgent
      if (userAgent.indexOf('Edge') > -1) {
        this.$nextTick(() => {
          this.collapsed = !this.collapsed
          setTimeout(() => {
            this.collapsed = !this.collapsed
          }, 16)
        })
      }
    },
    methods: {
      ...mapActions(['setSidebar']),
      toggle() {
        this.collapsed = !this.collapsed
        this.setSidebar(!this.collapsed)
      },
      paddingCalc() {
        let left = ''
        if (this.sidebarOpened) {
          left = this.isDesktop() ? '256px' : '80px'
        } else {
          left = (this.isMobile() && '0') || ((this.fixSidebar && '40px') || '0')
        }
        return left
      },
      menuSelect() {
        if (!this.isDesktop()) {
          this.collapsed = false
        }
      },
      drawerClose() {
        this.collapsed = false
      }
    }
  }
</script>

<style lang="less">
  @import url('../components/global.less');

  /*
   * The following styles are auto-applied to elements with
   * transition="page-transition" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the page transition by editing
   * these styles.
   */

  .page-transition-enter {
    opacity: 0;
  }

  .page-transition-leave-active {
    opacity: 0;
  }

  .page-transition-enter .page-transition-container,
  .page-transition-leave-active .page-transition-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

</style>